/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome';

const CommentForm = ({ id, parentId, color }) => {    
    const [notification, setNotification] = useState(false);
    const [error, setError] = useState(null);

    const validate = ({ target }) => {      
      const { value } = target;

      if (!value.length) {
        target.classList.remove('error');
        setError(null);
        return true;
      }

      if (target.type === 'email') {
        if (!value.match(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i)) {
          target.classList.add('error');
          setError(            
            <p className="error--container">
              <FontAwesomeIcon icon="exclamation-circle" size="lg" style={{color: 'var(--primary-text-alpha)', margin: '5px'}} /> 
              <span>Die E-Mail Adresse ist nicht gültig</span>
            </p>,
          );

          return false;
        }
      } else if (target.type === 'url') {
        if (!value.match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/)) {
          target.classList.add('error');
          setError(            
            <p className="error--container">
              <FontAwesomeIcon icon="exclamation-circle" size="lg" style={{color: 'var(--primary-text-alpha)', margin: '5px'}} /> 
              <span>Die URL ist nicht gültig</span>
            </p>,
          );

          return false;
        }
      } 

      if (target.validity && target.validity.tooShort) {
        target.classList.add('error');
        setError(            
          <p className="error--container">
            <FontAwesomeIcon icon="exclamation-circle" size="lg" style={{color: 'var(--primary-text-alpha)', margin: '5px'}} /> 
            <span>Es werden mindestens {target.minLength} Zeichen benötigt</span>
          </p>,
        );

        return false;
      }

      target.classList.remove('error');
      setError(null);
      return true;
    };

    const submit = async e => {
        e.preventDefault();

        const [post, parent, name, email, web, comment] = e.target.elements;
        const data = {
          post: post.value,
          parent: parent.value,
          author_name: name.value,
          author_email: email.value,
          author_url: web.value ?? '',
          content: comment.value,
        };
        console.log(name.value, email.value)
        if (data.parent === '')
          delete data.parent;

        if (name.value.length < 1) {
          name.classList.add('error');
          setError(            
            <p className="error--container">
              <FontAwesomeIcon icon="exclamation-circle" size="lg" style={{color: 'var(--primary-text-alpha)', margin: '5px'}} /> 
              <span>Es wird ein Name benötigt</span>
            </p>,
          );

          return;
        } else if (email.value.length < 1) {
          email.classList.add('error');
          setError(            
            <p className="error--container">
              <FontAwesomeIcon icon="exclamation-circle" size="lg" style={{color: 'var(--primary-text-alpha)', margin: '5px'}} /> 
              <span>Es wird Ihre E-Mail Adresse benötigt</span>
            </p>,
          );

          return;
        } else if (comment.value.length  < 1) {
          comment.classList.add('error');
          setError(            
            <p className="error--container">
              <FontAwesomeIcon icon="exclamation-circle" size="lg" style={{color: 'var(--primary-text-alpha)', margin: '5px'}} /> 
              <span>Es wird eine Nachricht benötigt</span>
            </p>,
          );

          return;
        }

        if (!validate({ target: email }) || !validate({ target: web }) || !validate({ target: name }))
          return;
        
        try {
          const res = await fetch(`https://xmalanderssein.de/wp-json/wp/v2/comments`, {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          });          

          if (res.status >= 200 && res.status < 300) {
            setNotification(
              <>
                <FontAwesomeIcon icon="check-circle" size="3x" style={{color: 'var(--primary-text-alpha)', flex: '1 1 100%'}} />
                <p style={{margin: '1em 0 0'}}>Ihr Kommentar steht zur redaktionellen Überprüfung aus.</p>
              </>
            );
          } else if (res.status >= 400 && res.status < 500) {
            const json = await res.json();
            setError(
              <p className="error--container">
                <FontAwesomeIcon icon="exclamation-circle" size="lg" style={{color: 'var(--primary-text-alpha)', margin: '5px'}} /> 
                <span>{json.message}</span>
              </p>
            );
          }                 
        } catch (err) {
          console.error('Error:', err);
          setError(            
            <p className="error--container">
              <FontAwesomeIcon icon="exclamation-circle" size="lg" style={{color: 'var(--primary-text-alpha)', margin: '5px'}} /> 
              <span>{err.message}</span>
            </p>
          );
        }                              
    };    

    const handleInvalid = e => {
      //e.preventDefault();
      validate(e);
    };

    const urlBlur = ({ target }) => {
      if (!target.value.includes('http') && target.value.length > 0)
        target.value = `https://${target.value}`;
        validate({ target })
    };

    const Notify = ({ msg }) => <div>{msg}</div>

    return (  
        !notification ?
          <form onSubmit={submit}>                    
              <section style={{background: color ?? '#f9f9f9', display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: '.25em', position: 'relative'}}>              
                { error }        
                <input name="post" value={id} type="hidden" />
                <input name="parent" value={parentId} type="hidden" /> 
                <input name="name" required placeholder="Name" minLength={2} onChange={validate} onInvalid={handleInvalid} type="text" />
                <input name="email" onChange={validate}  required type="email" onInvalid={handleInvalid} placeholder="Mail" />
                <input name="url" onChange={validate}  type="url" placeholder="Web" onInvalid={handleInvalid} onBlur={urlBlur} />
                <textarea name="comment" required onChange={validate} onInvalid={handleInvalid} minLength={10} placeholder="Ihr Kommentar..." />
                <button type="submit" style={{marginBottom: parentId ? '0' : '1em', cursor: 'pointer'}}>
                  <FontAwesomeIcon icon="paper-plane" size="lg" />
                </button>
              </section>
          </form>
        : 
          <form>
            <section style={{
              display: 'flex', 
              flexWrap: 'wrap', 
              justifyContent: 'center', 
              alignItems: 'center', 
              textAlign: 'center',
              padding: '50px 0',
            }}>
              <Notify msg={notification} />
            </section>
          </form>
        
    );
}

export default CommentForm;